import { Product } from '../types';

// 자전거 이미지
import bicycle4040123182 from '../assets/bicycle/4040-123182.png';
import bicycle4040123183 from '../assets/bicycle/4040-123183.png';
import bicycle4040123185 from '../assets/bicycle/4040-123185.png';
import bicycle4040123187 from '../assets/bicycle/4040-123187.png';
import bicycle4040123188 from '../assets/bicycle/4040-123188.png';

// 브랜드 로고
import giantLogo from '../assets/brandlogo/giant-logo.png';
import ridleyLogo from '../assets/brandlogo/ridley-logo.png';
import cerveloLogo from '../assets/brandlogo/cervelo-logo.png';
import specializedLogo from '../assets/brandlogo/specialized-logo.png';
import nicolaiLogo from '../assets/brandlogo/Nicolai-logo.png';

export const productData: Record<string, Product> = {
  '4040-123182': {
    ur: '4040-123182',
    product: {
      productImage: bicycle4040123182,
      productNum: 'GJ884524',
      brand: 'Giant',
      productName: 'Giant Bicycle',
      brandLogo: giantLogo,
    },
  },
  '4040-123183': {
    ur: '4040-123183',
    product: {
      productImage: bicycle4040123183,
      productNum: 'WSBC6040155863G',
      brand: 'Specialized',
      productName: 'Specialized Bicycle',
      brandLogo: specializedLogo,
    },
  },
  '4040-123185': {
    ur: '4040-123185',
    product: {
      productImage: bicycle4040123185,
      productNum: 'SNS3D17L01366',
      brand: 'Cervelo',
      productName: 'Cervelo Bicycle',
      brandLogo: cerveloLogo,
    },
  },
  '4040-123187': {
    ur: '4040-123187',
    product: {
      productImage: bicycle4040123187,
      productNum: '190404828',
      brand: 'Nicolai',
      productName: 'Nicolai Bicycle',
      brandLogo: nicolaiLogo,
    },
  },
  '4040-123188': {
    ur: '4040-123188',
    product: {
      productImage: bicycle4040123188,
      productNum: '426845',
      brand: 'Ridley',
      productName: 'Ridley Bicycle',
      brandLogo: ridleyLogo,
    },
  },
};

export const getProductByUrcode = (urcode: string): Product | undefined => {
  return productData[urcode];
};

export const getAllProducts = (): Product[] => {
  return Object.values(productData);
};
